import Moment from "moment";
import { extendMoment } from "moment-range";

//<<< moment range plugin >>>
const moment = extendMoment(Moment);

var DisabledDates = (item, DATA, OPT, _monthCounter = 12) => {
	var _startDate,
		_endDate,
		_sortedStartDates,
		_sortedEndDates,
		_rangeToCheck,
		availableDates = [],
		disabledDates,
		interval = "month";
	var dateFilter = (list, callback) => {
		let storage = [];
		for (let i = 0; i < list.length; i++) {
			storage[i] = callback(list[i]);
		}
		return storage;
	};
	var startDateCompare = (a, b) => {
		var x = moment(a.date_from);
		var y = moment(b.date_from);
		if (x > y) return 1;
		if (x < y) return -1;
	};
	var endDateCompare = (a, b) => {
		var x = Date.parse(a.date_to);
		var y = Date.parse(b.date_to);
		if (x > y) return 1;
		if (x < y) return -1;
	};
	var itemStatusCheck = (v) => {
		var status = v.status < 1 ? 0 : v.status === 1 ? 1 : v.status >= 4 ? 0 : 1;
		return status;
	};
	var iteratingList = (list1, list2, expandDateCb) => {
		for (let i = 0; i < list1.length; i++) {
			if (list1[i].status !== 0) {
				availableDates.push(
					...expandDateCb(list1[i].start, list2[i].end, list1[i].units)
				);
			}
		}
	};
	(() => {
		_rangeToCheck = moment.rangeFromInterval(
			interval,
			_monthCounter,
			new Date(Date.now())
		);
	})();
	_startDate = dateFilter(DATA, (v) => {
		return {
			start: moment(v.date_from, "YYYY-MM-DD"),
			units: v.units,
			status: itemStatusCheck(v)
		};
	});
	_endDate = dateFilter(DATA, (v) => {
		return {
			end: moment(v.date_to, "YYYY-MM-DD"),
			units: v.units,
			status: itemStatusCheck(v)
		};
	});
	_sortedStartDates = _startDate.sort(startDateCompare);
	_sortedEndDates = _endDate.sort(endDateCompare);
	//calling iterator with the callbacks.
	iteratingList(_sortedStartDates, _sortedEndDates, (iStart, iEnd, units) => {
		var test = [];
		//console.log(iStart);
		if (iStart.isValid() && iEnd.isValid()) {
			var range1 = moment().range(iStart, iEnd);
			for (let days of _rangeToCheck.by("days")) {
				if (
					days.within(range1, { excludeStart: false }, { excludeEnd: false })
				) {
					let dayIndex = availableDates.findIndex(
						(date) => date.date === days.format("YYYY-MM-DD")
					);
					if (dayIndex !== -1) {
						availableDates[dayIndex].units = JSON.stringify(
							parseInt(availableDates[dayIndex].units) + parseInt(units)
						);
					} else {
						let dayData = { date: days.format("YYYY-MM-DD"), units };
						availableDates.push(dayData);
					}
				}
			}
			test.push({ date: iEnd.format("YYYY-MM-DD"), units });
		} else {
			for (let days of _rangeToCheck.by("days")) {
				let dayIndex = availableDates.findIndex(
					(date) => date.date === days.format("YYYY-MM-DD")
				);
				if (dayIndex !== -1) {
					availableDates[dayIndex].units = JSON.stringify(
						parseInt(availableDates[dayIndex].units) + parseInt(units)
					);
				} else {
					let dayData = { date: days.format("YYYY-MM-DD"), units };
					availableDates.push(dayData);
				}
			}
		}
		//console.log(availableDates);
		return test;
	});

	disabledDates = () => {
		var x = availableDates.reduce((accumulator, currentValue) => {
			if (parseInt(currentValue.units) >= item.units) {
				accumulator.push(currentValue.date);
			}
			return accumulator;
		}, []);
		return x;
	};

	if (OPT === "DD") {
		return disabledDates();
	} else if (OPT === "UNITS") {
		return availableDates;
	}
};

export default DisabledDates;
